import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 13\" id=\"arrow-right\"><path d=\"M.59 11.09 2 12.5l6-6-6-6L.59 1.91 5.17 6.5.59 11.09Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol